PJQ.views.invoicing.InvoicingManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management'),
        subTemplates: {
            totals: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'invoicing-management-totals')
        }
    },
    events: {
        'shown.bs.tab .nav-tabs': 'tabActivated',
    },
    beforeFirstRender: function () {
        this.options.isAdmin = PJQ.app.session.project.hasPermission('payableInvoices.isAdmin') || PJQ.app.session.project.hasPermission('receivableInvoices.isAdmin');
        this.options.canViewPayableInvoices = PJQ.app.session.project.hasPermission('payableInvoices.canView');
        this.options.canViewReceivableInvoices = PJQ.app.session.project.hasPermission('receivableInvoices.canView');
    },
    renderData: function () {
        return {
            isAdmin: this.options.isAdmin,
            payableInvoices: this.payableInvoices
        }
    },
    afterRender: function () {
        if (this.options.view != null) {
            this.activateTab(this.options.view);
        } else if (this.options.canViewPayableInvoices) {
            this.renderPayableInvoicesView();
        } else if (this.options.canViewReceivableInvoices) {
            this.renderReceivableInvoicesView();
        } else if (this.options.isAdmin) {
            this.renderBillingPeriodsView();
        }
    },
    activateTab: function (tab) {
        switch (tab ? tab.toLowerCase() : null) {
            case 'billingperiods':
                tab = 'BP_List';
                this.renderBillingPeriodsView();
                break;
            case 'receivable':
                tab = 'RI_List';
                this.renderReceivableInvoicesView();
                break;
            default:
                tab = 'PI_List';
                this.renderPayableInvoicesView();
                break;
        }
        this.activeTab = '#' + tab;

        this.isActivating = true;
        this.$('.nav-link[href="#' + tab + '"]').tab('show');
        this.isActivating = false;
    },
    tabActivated: function (e) {
        if(this.isActivating){
            return;
        }

        let tab = $(e.target).attr('href');
        if(this.activeTab !== tab) {
            this.activeTab = tab;
            switch (this.activeTab) {
                case '#PI_List':
                    this.renderPayableInvoicesView();
                    break;
                case '#RI_List':
                    this.renderReceivableInvoicesView();
                    break;
                case '#BP_List':
                    this.renderBillingPeriodsView();
                    break;
            }
        }
    },
    renderPayableInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing', {
            trigger: false
        });
        this.activeView = 'payable';
        if (this.payableView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.payableView = new PJQ.views.invoicing.PayableInvoicesList({
                    el: this.$('.payable-pane'),
                    project: PJQ.app.session.project,
                    collection: this.payableInvoices,
                    invoiceId: this.options.invoiceId,
                    paymentId: this.options.paymentId,
                    onChange: _.bind(function(invoice) {
                        let currentInvoice = this.payableInvoices.get(invoice.id);
                        currentInvoice.set(invoice.attributes);
                        this.renderStats();
                    }, this)
                });
                this.renderStats();
            }, this);
            if (this.payableInvoices == null) {
                this.payableInvoices = new PJQ.collections.invoicing.PayableInvoices(null, {
                    project: this.options.project
                });
                this.payableInvoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderReceivableInvoicesView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing/receivable', {
            trigger: false
        });
        this.activeView = 'receivable';
        if (this.receivableView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.receivableView = new PJQ.views.invoicing.ReceivableInvoicesList({
                    el: this.$('.receivable-pane'),
                    project: PJQ.app.session.project,
                    collection: this.receivableInvoices,
                    invoiceId: this.options.invoiceId,
                    paymentId: this.options.paymentId,
                    onChange: _.bind(function(invoice) {
                        let currentInvoice = this.receivableInvoices.get(invoice.id);
                        currentInvoice.set(invoice.attributes);
                        this.renderStats();
                    }, this)
                });
                this.renderStats();
            }, this);
            if (this.receivableInvoices == null) {
                this.receivableInvoices = new PJQ.collections.invoicing.ReceivableInvoices(null, {
                    project: this.options.project
                });
                this.receivableInvoices.fetch({
                    success: _.bind(function () {
                        fnRender();
                    }, this)
                })
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderBillingPeriodsView: function () {
        PJQ.app.router.navigate('projects/' + this.options.project.id.toString() + '/invoicing/billingperiods', {
            trigger: false
        });
        this.activeView = 'billing_periods';
        if (this.billingPeriodsView == null && this.options.canViewPayableInvoices) {
            let fnRender = _.bind(function () {
                this.billingPeriodsView = new PJQ.views.invoicing.BillingPeriodsList({
                    el: this.$('.billing-period-pane'),
                    project: PJQ.app.session.project,
                    model: this.billingPeriodSettings
                });
            }, this);
            if (this.billingPeriodSettings == null) {
                PJQ.app.session.project.fetchBillingPeriodSettings(_.bind(function (bst) {
                    this.billingPeriodSettings = bst;
                    fnRender();
                }, this));
            } else {
                fnRender();
            }
        } else {
            this.renderStats();
        }
    },
    renderStats: function () {
        let totals = null,
            data = null,
            $totals = this.$('.totals-outer');
        if (this.activeView === 'receivable') {
            totals = this.receivableInvoices.getTotalAmountsByStatus();
            data = {
                draft: totals[PJQ.constants.invoicing.receivableInvoiceStatus.DRAFT],
                reviewing: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVIEWING],
                approved: totals[PJQ.constants.invoicing.receivableInvoiceStatus.APPROVED],
                complete: totals[PJQ.constants.invoicing.receivableInvoiceStatus.COMPLETE],
                revise: totals[PJQ.constants.invoicing.receivableInvoiceStatus.REVISE]
            };
        } else if (this.activeView === 'payable') {
            totals = this.payableInvoices.getTotalAmountsByStatus();
            data = {
                draft: totals[PJQ.constants.invoicing.payableInvoiceStatus.DRAFT],
                reviewing: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVIEWING],
                approved: totals[PJQ.constants.invoicing.payableInvoiceStatus.APPROVED],
                complete: totals[PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE],
                revise: totals[PJQ.constants.invoicing.payableInvoiceStatus.REVISE]
            };
        }
        if (data != null) {
            this.renderSubTemplate(false, this.options.subTemplates.totals, $totals, data);
        } else {
            $totals.empty();
        }
    }
});